import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../services/api';

let companyCache = null;

// Floating WhatsApp button (site-wide, not in admin); message pre-filled with the product on product pages
const WhatsAppButton = () => {
  const location = useLocation();
  const [phone, setPhone] = useState(companyCache?.phone || '');
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (companyCache) { setPhone(companyCache.phone || ''); return; }
    api.get('/company').then(r => { companyCache = r.data || {}; setPhone(companyCache.phone || ''); }).catch(() => {});
  }, []);

  const productId = location.pathname.match(/^\/produit\/([^/]+)/)?.[1];
  useEffect(() => {
    if (!productId) { setProduct(null); return; }
    api.get(`/products/${productId}`).then(r => setProduct(r.data)).catch(() => setProduct(null));
  }, [productId]);

  if (!phone || location.pathname.startsWith('/admin')) return null;
  const number = phone.replace(/\D/g, '');
  const text = product
    ? `Bonjour, j'ai une question sur : ${product.name} (réf. ${product.ref || product.id}) – ${window.location.origin}/produit/${product.slug || product.id}`
    : "Bonjour, j'ai une question concernant OTOPIECES.COM";
  return (
    <a href={`https://wa.me/${number}?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" aria-label={`WhatsApp ${phone}`} title={`WhatsApp ${phone}`}
      data-testid="whatsapp-button" data-product={product?.id || ''}
      className="fixed bottom-6 right-24 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5d] shadow-lg flex items-center justify-center transition-transform hover:scale-105">
      <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff" aria-hidden="true"><path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.6 1.9 6.5L4 29l7.8-1.9c1.8 1 3.9 1.5 6 1.5h.2c6.6 0 12-5.3 12-11.9C30 8.3 24.6 3 16 3zm0 21.8c-1.9 0-3.7-.5-5.3-1.5l-.4-.2-4 1 1.1-3.8-.3-.4A9.7 9.7 0 0 1 6.1 15C6.1 9.5 10.5 5 16 5s9.9 4.5 9.9 10-4.4 9.8-9.9 9.8zm5.4-7.3c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-1 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.2-.6-.3z"/></svg>
    </a>
  );
};

export default WhatsAppButton;
